import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { getVehicles } from "../../api/apiGetrequest";
import { AddDriveImage, AddVehicleRepairRequest } from "../../api/apirequest";

const styles = {
  container: {
    width: "100%",
    padding: "16px",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
  },
  inputField: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #cbd5e0",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
    marginBottom: "12px",
  },
  addButton: {
    padding: "8px 16px",
    backgroundColor: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  imagePreview: {
    width: "100%",
    maxWidth: "300px",
    height: "auto",
    marginTop: "10px",
    borderRadius: "6px",
  },
};

const details = JSON.parse(localStorage.getItem("user"));

const AddnewRepairRequest = ({ setOpen ,fetchRepairs}) => {
  const [newRepair, setNewRepair] = useState({
    repairID: 0,
    vehicleID: null,
    repairDescription: null,
    repairImageID: null,
    repairSource: "Request",
    assignedTo: 0,
    mechNotes: "",
    repairCost: 0,
    dateAdded: new Date().toISOString(),
    dateClosed: "",
    statusID: 0,
    addedBy: details?.data?.userID,
  });

  const [loading, setLoading] = useState(false);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [error, setError] = useState("");
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getVehicles();
        setVehicleOptions(
          result?.map((v) => ({ value: v.VehicleID, label: v.VregNO }))
        );
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!newRepair.repairDescription.trim()) {
      setError("Repair description is required.");
      setLoading(false);
      return;
    }

    if (!newRepair.vehicleID) {
      setError("Please select a vehicle.");
      setLoading(false);
      setOpen();
      return;
    }

    try {
      let imageResult = null;

      // Only upload image if one is selected
      if (newRepair.repairImageID) {
        imageResult = await AddDriveImage({
          base64Image: newRepair.repairImageID,
          fileName: new Date().toISOString().replace(/:/g, "-"), // Safe filename
        });

        if (!imageResult.FileId) {
          throw new Error(imageResult.message || "Failed to upload the image.");
        }
      }

      // Submit Repair Request
      const result = await AddVehicleRepairRequest({
        ...newRepair,
        repairImageID: imageResult?.FileId || "", // Use FileId if available, otherwise an empty string
      });

      if (result?.success) {
        toast.success(result.message || "Repair successfully added!");
        setNewRepair({
          repairDescription: "",
          repairImageID: "",
          vehicleID: null,
        });
        setPreviewImage(null);
        setOpen()
        fetchRepairs()
      } else {
        throw new Error(
          result.message || "An error occurred while adding repair."
        );
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error.message || "There was an error processing your request."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setNewRepair((prev) => ({ ...prev, repairImageID: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div style={styles.container}>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column" }}
      >
        {error && (
          <p style={{ color: "red", fontSize: "14px", marginBottom: "8px" }}>
            {error}
          </p>
        )}

        <textarea
          placeholder="Repair Description"
          style={styles.inputField}
          rows="3"
          value={newRepair.repairDescription}
          onChange={(e) =>
            setNewRepair({ ...newRepair, repairDescription: e.target.value })
          }
        />

        <input
          type="file"
          accept="image/*"
          style={styles.inputField}
          onChange={handleImageChange}
        />

        {previewImage && (
          <img src={previewImage} alt="Repair" style={styles.imagePreview} />
        )}

        <div style={{ marginBottom: "12px" }}>
          <Select
            options={vehicleOptions}
            value={vehicleOptions?.find(
              (option) => option.value === newRepair.vehicleID
            )}
            onChange={(selectedOption) =>
              setNewRepair({
                ...newRepair,
                vehicleID: selectedOption?.value || null,
              })
            }
            placeholder="Select Vehicle"
            isSearchable={true}
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: state.isFocused
                  ? "2px solid #3b82f6"
                  : "1px solid #cbd5e0",
                borderRadius: "6px",
                boxShadow: state.isFocused
                  ? "0 0 0 2px rgba(59, 130, 246, 0.5)"
                  : "none",
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 100,
              }),
            }}
          />
        </div>
        

        <button disabled={loading} type="submit" style={styles.addButton}>
          {loading ? "Submitting Repair..." : "Add Repair"}
        </button>
      </form>
    </div>
  );
};

export default AddnewRepairRequest;
